import request from '@/utils/request'
const projextName = 'OCT' /// 服务器
// const projextName = 'oct'// 本地
/**
 * 获取txt文档
 * @param {*} fileurl
 * @returns
 */
// 获取txt并处理返回数据
export function txtData (fileurl, headers = {}) {
  return request(fileurl, 'get', headers)
}

/**
 * 登录
 * @param {*} url
 * @returns
 */
export function login (data, headers = {}) {
  return request(`/api/${projextName}/user/login`, 'post', headers, data)
}

/**
 * 批量上傳dbfiles
 * @param {*} file,md5
 * @returns
 */
export function batchUpload (data, headers = {}, onUploadProgress) {
  return request(`/api/${projextName}/file/batchUpload`, 'post', headers, data, onUploadProgress)
}

/**
 * 批量上傳dbfiles--自動模式下
 * @param {*} file,md5
 * @returns
 */
export function batchAIUpload (data, headers = {}, onUploadProgress) {
  return request(`/api/${projextName}/file/batchUpload`, 'post', headers, data, onUploadProgress)
}

/**
 * 獲取手動上傳數據
 * @param {*} unique
 * @returns
 */
export function getFileList (data, headers = {}) {
  const data1 = {
    uniqueId: data
  }
  return request(`/api/${projextName}/file/getFile`, 'post', headers, data1)
}
/**
 * 獲取自動數據
 * @param {*} unique
 * @returns
 */
export function getAIFileList (data, headers = {}) {
  return request(`/api/${projextName}/file/eveFC`, 'post', headers, data)
}
/**
 * 獲取醫生數據
 * @param {*}
 * @returns
 */
export function getDoctorList (data, headers = {}) {
  return request(`/api/${projextName}/user/getAllUser`, 'get', headers)
}

/**
 * 批量上傳txt files
 * @param {*} file,md5
 * @returns
 */
export function batchTxtFile (data, headers = {}) {
  console.log('data', data)

  return request(`/api/${projextName}/file/batchTxtFile`, 'post', headers, data)
}
/**
 * 發送驗證碼---二次封裝的
 * @param {*} url
 * @returns
 */
export function sendSms (data, headers = {}) {
  return request(`/api/${projextName}/user/sendSms`, 'post', headers, data)
}
/**
 * 登录驗證碼
 * @param {*} url
 * @returns
 */
export function loginSms (data, headers = {}) {
  return request(`/api/${projextName}/user/loginSms`, 'post', headers, data)
}
// 获取验证码--后台
export function getImgCode (data, headers = {}) {
  return request(`/api/${projextName}/user/captchaImage`, 'get', headers)
}

// 清空上传缓存接口
export function redisClear (headers = {}) {
  return request(`/api/${projextName}/file/redisClear`, 'get', headers)
}
